<template>
    <div id="intentionList">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/skillList' }">技能列表</el-breadcrumb-item>
        <el-breadcrumb-item>创建意图</el-breadcrumb-item>
      </el-breadcrumb>
     <p>
       <router-link :to="{ path:'/createIntention?skillId='+skill_id,query:{online:this.online} }" v-if="!onlineFlag"><el-button type="primary" :disabled="local" round size="small" class="font-size-btn">创建意图</el-button></router-link>
       <el-button @click="toSystemList" v-if="!onlineFlag" type="primary" style="margin-left: 10px" :disabled="local" class="font-size-btn"  round size="small">引用系统意图</el-button>
     </p>
      <div>
        <template>
          <el-table
            :data="tableData"
            style="width: 100%;overflow: hidden;">
            <el-table-column
              prop="chinese_name"
              align="center"
              label="意图中文名">
            </el-table-column>
            <el-table-column
              prop="intent"
              align="center"
              label="意图标识名">
            </el-table-column>
            <el-table-column
              align="center"
              label="来源">
              <template slot-scope="scope">
                {{scope.row.source == 1 ? '自定义' : '系统'}}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="操作">
              <template slot-scope="scope">
                <!--<router-link :to="'/editIntention?skillId='+skill_id+'&intent_id='+scope.row.id">-->
                  <el-button type="text" size="mini" v-if="scope.row.source == 1" :disabled="onlineFlag" @click="editRow(scope.row)">编辑</el-button>
                <!--</router-link>-->
                <el-button v-if="scope.row.source == 1" type="text"  size="mini" @click="removeInt(scope.row.id)" :disabled="onlineFlag">删除</el-button>
                <el-button v-if="scope.row.source == 0" type="text" size="mini" :disabled="onlineFlag" @click="SysInt(scope.row.id)">取消引用</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
    </div>
</template>
<script>
  import qs from 'qs'
  import {getIntentsApi, removeintApi, calSysIntApi} from '@/api'
    export default {
        data() {
            return {
              skill_id: null,
              online:'',
              value2: true,
              tableData: [],
              onlineFlag:null,
              local:false
            }
        },
      created () {
          this.getUserId()
          this.intents()
        this.isCanInput()
        this.onlineFlag = eval(localStorage.getItem('onlineFlag') == '1')
      },
        methods: {
          editRow(row){
            this.$router.push({path:'/editIntention?skillId='+this.skill_id+'&intent_id='+row.id + '&online='+this.online})
          },
          toSystemList(){
            this.$router.push({path:'/systemList?skillId='+this.skill_id+'&online='+this.online})
          },
          isCanInput(){
            if(localStorage.getItem('onlineFlag') == '1'){
              this.local = true;
            }else{
              this.local = false;
            }
          },
          async getUserId () {
//            this.$route.query.skillId ? void(0) : this.$router.push('/skillList')
            this.skill_id = this.$route.query.skillId
            this.online = this.$route.query.online
          },
          async intents () {
            let res = await getIntentsApi(this.skill_id)
            if (res.data.code == 200) {
              this.tableData = res.data.data
            } else {
              this.$message({message: '当前网络状况异常，请稍后再试', type: 'error'})
            }

          },
          removeInt (id) {
            this.$confirm('是否删除此意图?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              removeintApi(id).then(res => {
                if (res.data.code == 200) {
                    console.log(res.data.data.msg)
                    if (res.data.data.msg == 'unsucess') {
                        this.$message({
                            type: 'info',
                            message: '用户模型训练中···'
                        })
                    } else {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        })
                    }
                  this.intents()
                } else {
                  this.$message({
                    type: 'error',
                    message: '删除失败!'
                  })
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              })
            })
          },
          async SysInt (id) {//取消系统引用
              let res = await calSysIntApi(qs.stringify({skill_id: this.skill_id, intents: [id]}))
            this.intents()
          },
        }
    }
</script>
<style  rel="stylesheet/scss" lang="scss">
#intentionList{
  .iconfont{
   font-size:20px;
  }
  padding:30px;
  p{
    button{
      width: 145px;
      margin-bottom:20px;
    }
  }
  .font-size-btn{
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/skill/intention/IntentionList.vue